import React from 'react';
import classes from './ResetPassword.module.scss';
import Txt from 'components/atoms/Txt/Txt';
import { LOGIN } from '../pages';
import A from 'components/atoms/A/A';

export const ResetSuccess = () => (
  <div className={classes.finalSuccessStep}>
    <Txt>Your password has been updated.</Txt>
    <A href={LOGIN.path} data-label="login-from-reset-password">
      <Txt>Log in to account</Txt>
    </A>
  </div>
);
